import { useMyAdherentSummary, useSsoService } from "@pharmupp/p3-front-commons"

export const useEmailInfo = () => {
  const { summary } = useMyAdherentSummary()
  const connectedUserName = useSsoService().getFullName() ?? "-"
  return { connectedUserName, pharmacieName: summary?.name ?? "-" }
}
